import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionMetadata", "flowObjectTypeId", "getHeaderTitle", "actionId"];
import PropTypes from 'prop-types';
// @ts-expect-error untyped module
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import DelayUntilDateActionMetadata from 'automation-ui-action-features/actions/delay-until-date/DelayUntilDateActionMetadata';
import DelayUntilDateActionSummary from 'automation-ui-action-features/actions/delay-until-date/DelayUntilDateActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
const DelayUntilDateActionCard = _ref => {
  let {
      actionMetadata,
      flowObjectTypeId,
      getHeaderTitle,
      actionId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId
    }),
    content: /*#__PURE__*/_jsx(DelayUntilDateActionSummary, {
      actionMetadata: actionMetadata,
      flowObjectTypeId: flowObjectTypeId
    })
  }));
};
DelayUntilDateActionCard.propTypes = {
  getHeaderTitle: PropTypes.func.isRequired,
  actionMetadata: PropTypes.instanceOf(DelayUntilDateActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType.isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default DelayUntilDateActionCard;